"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueForCustomizableValue = exports.uniqueReasonsMessage = exports.uniqueDisciplinesMessage = exports.uniqueKeywordsMessage = void 0;
exports.uniqueKeywordsMessage = "Keywords must be unique";
exports.uniqueDisciplinesMessage = "Disciplines must be unique";
exports.uniqueReasonsMessage = "Reasons must be unique";
const uniqueForCustomizableValue = (errorMessage) => [
    (data) => {
        var _a, _b;
        // validate value list items are unique
        const filteredValueListItems = data === null || data === void 0 ? void 0 : data.filter(isIdValue);
        const uniqueValueListItems = new Set(filteredValueListItems === null || filteredValueListItems === void 0 ? void 0 : filteredValueListItems.map((value) => value.id)).size === ((_a = filteredValueListItems === null || filteredValueListItems === void 0 ? void 0 : filteredValueListItems.length) !== null && _a !== void 0 ? _a : 0);
        // validate custom value items are unique
        const filteredCustomValues = data === null || data === void 0 ? void 0 : data.filter(isCustomValue);
        const uniqueCustomValueListItems = new Set(filteredCustomValues === null || filteredCustomValues === void 0 ? void 0 : filteredCustomValues.map((value) => value.customName.toLowerCase())).size ===
            ((_b = filteredCustomValues === null || filteredCustomValues === void 0 ? void 0 : filteredCustomValues.length) !== null && _b !== void 0 ? _b : 0);
        return uniqueValueListItems && uniqueCustomValueListItems;
    },
    { message: errorMessage },
];
exports.uniqueForCustomizableValue = uniqueForCustomizableValue;
const isCustomValue = (data) => data.customName !== undefined;
const isIdValue = (data) => data.id !== undefined;
//# sourceMappingURL=uniqueForCustomizableValue.js.map